<template>
  <div>
    <div class="desktop_profile">
      <main-profile-admin
        @uprofile="editProfile"
        @refetch="fetchData"
        :loading="loading"
        :myData="dataSet"
      />
    </div>
    <v-row no-gutters class="my-2" v-if="dataSet">
      <v-col cols="12" md="9" class="pa-2">
        <v-card class="pa-3 rounded-lg" flat>
          <div class="d-flex justify-space-between">
            <h3 class="mb-3">Bio</h3>
            <v-btn icon color="var(--g)" @click="editBio" v-if="dataSet.bio">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <p class="mb-0" v-if="dataSet.bio" v-html="dataSet.bio"></p>
          <div class="d-flex justify-center align-center flex-column" v-else>
            <p>You haven't added <b class="color_default">Bio</b> yet</p>
            <v-btn
              depressed
              color="var(--g)"
              class="text-capitalize"
              @click="editBio"
              dark
              >Add Bio</v-btn
            >
          </div>
        </v-card>
        <v-card class="pa-5 mt-4 rounded-lg" flat>
          <div class="d-flex align-center justify-space-between mb-3">
            <h3 class="mr-2">Sector of Expertise</h3>
            <v-btn
              icon
              color="var(--g)"
              v-if="dataSet.expertise.length"
              @click="editExpertise"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <div
            class="d-flex justify-center align-center flex-column"
            v-if="!dataSet.expertise.length"
          >
            <p class="text-center">
              You haven't added <b class="color_default">Expertise</b> yet
            </p>
            <v-btn
              depressed
              color="var(--g)"
              class="text-capitalize"
              @click="editExpertise"
              dark
              >Add Expertise</v-btn
            >
          </div>
          <div
            class="d-flex align-center flex-wrap my-2"
            v-if="dataSet.expertise.length"
          >
            <v-card
              v-for="(item, n) in dataSet.expertise"
              :key="n"
              outlined
              tile
              class="d-flex align-center justify-space-between ma-1 px-1 py-1 rounded-lg"
              color="rgba(0, 99, 65, 0.2)"
            >
              <h5 style="color: #006341" class="mx-3">
                {{ item }}
              </h5>
            </v-card>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" class="pa-2">
        <v-card class="pa-5 rounded-lg" flat>
          <div class="d-flex justify-space-between">
            <h3>Contact</h3>
            <v-btn
              icon
              color="var(--g)"
              v-if="dataSet.contact.length"
              @click="editContact"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <div
            class="d-flex justify-center align-center flex-column"
            v-if="!dataSet.contact.length"
          >
            <p class="text-center">
              You haven't added <b class="color_default">Contact</b> yet
            </p>
            <v-btn
              depressed
              color="var(--g)"
              class="text-capitalize"
              @click="editContact"
              dark
              >Add Contact</v-btn
            >
          </div>
          <div class="mt-3" v-if="dataSet.contact.length">
            <div v-for="(item, i) in dataSet.contact" :key="i">
              <div class="mb-3" v-if="item.value">
                <v-icon class="mr-2" color="var(--g)"
                  >mdi-{{ item.name }}</v-icon
                >
                {{ item.value }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <div class="pa-2">
      <dialog-profile
        :d_profile="d_profile"
        @refetch="fetchData"
        @close="d_profile = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        :width="d_width"
        :line="true"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MainProfileAdmin from "../../components/profile/tf/mainProfileAdmin.vue";
import MainProfileVendor from "../../components/profile/vendor/mainProfileVendor.vue";
import DialogProfile from "./dialogProfile.vue";

export default {
  name: "profileadmin",
  components: {
    MainProfileAdmin,
    MainProfileVendor,
    DialogProfile,
  },
  computed: {
    ...mapState({
      id: (state) => state.id,
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  data() {
    return {
      dataSet: null,
      d_profile: false,
      inventory: "",
      d_type: "",
      d_title: "",
      d_width: "",
      loading: false,

      contact: [
        {
          name: "instagram",
          value: "",
        },
        {
          name: "facebook",
          value: "",
        },
        {
          name: "twitter",
          value: "",
        },
        {
          name: "linkedin",
          value: "",
        },
        {
          name: "youtube",
          value: "",
        },
        {
          name: "phone",
          value: "",
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      // vendor_user
      let role = this.$route.params.profileType == "TF" ? "tf" : "vendor_user";
      let data = {
        path: `manage/${role}?filter[user_id]=${this.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.$store.commit("GET_PROFILE", data.data[0]);
          this.dataSet = data.data[0];
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    editProfile() {
      this.d_type = "u_profileTF";
      this.d_title = "Edit Profile";
      this.inventory = this.dataSet;
      this.d_width = "50%";
      this.d_profile = true;
    },
    editBio() {
      this.d_type = "u_bio";
      this.d_title = "Edit Bio";
      this.inventory = {
        id: this.id,
        bio: this.dataSet.bio,
      };
      this.d_width = "50%";
      this.d_profile = true;
    },
    editExpertise() {
      this.d_type = "u_expertiseTF";
      this.d_title = "Edit Expertise";
      this.inventory = {
        id: this.id,
        expertise: this.dataSet.expertise,
      };
      this.d_width = "50%";
      this.d_profile = true;
    },
    editContact() {
      let contact = this.dataSet.contact.length
        ? this.dataSet.contact
        : this.contact;
      this.inventory = {
        id: this.id,
        contact: JSON.parse(JSON.stringify(contact))
      };
      this.d_type = "u_contactTF";
      this.d_title = "Edit Contact";
      this.d_width = "35%";
      this.d_profile = true;
    },
  },
};
</script>

<style></style>
